/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebstepfetch3Inputs */

const en_placewebstepfetch3 = /** @type {(inputs: Placewebstepfetch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading the website`)
};

const de_placewebstepfetch3 = /** @type {(inputs: Placewebstepfetch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website lesen`)
};

/**
* | output |
* | --- |
* | "Reading the website" |
*
* @param {Placewebstepfetch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebstepfetch3 = /** @type {((inputs?: Placewebstepfetch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebstepfetch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebstepfetch3(inputs)
	return de_placewebstepfetch3(inputs)
});
export { placewebstepfetch3 as "placeWebStepFetch" }